import { LegalLayout } from "./components/legalLayout";
import { SECURITY } from "./content/security";

/** /seguranca — medidas de segurança, vulnerabilidades e golpes. */
export const Seguranca = () => <LegalLayout document={SECURITY} />;
